import axios, { type InternalAxiosRequestConfig, type AxiosError } from 'axios';
import i18n from '../i18n/config';
import { sanitizeLanguage } from './i18n-safe';
import { getAccessToken } from './supabase';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '',
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = getAccessToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    config.headers['Accept-Language'] = sanitizeLanguage(i18n.language);

    // Generate a per-request correlation ID so browser network panel, Django logs,
    // and Sentry breadcrumbs all share the same request_id.
    config.headers['X-Request-ID'] = crypto.randomUUID();

    return config;
}, (error: AxiosError) => {
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            if (!error.config?.url?.includes('/api/v1/users/me/')) {
                window.dispatchEvent(new CustomEvent('auth:unauthorized'));
            }
        }
        return Promise.reject(error);
    }
);

export default api;
